module.exports = __webpack_public_path__ + "img/nav_11.dae35cd8.png";